import { KONVA_REFS } from "../common/constants";
import Konva from 'konva';
export const mapShapesToPolygons = (shapesLayer, shapes = [], useEvents = true, imageBoundingBox, options, onClick, onShapeMouseEnter, onShapeMouseLeave) => {
    if (!imageBoundingBox) {
        return;
    }
    shapes.forEach((shape) => {
        const polygon = new Konva.Line(Object.assign(Object.assign(Object.assign({ id: shape.id, name: KONVA_REFS.shape, points: mapCoordinatesToPoints(shape.coordinates, imageBoundingBox), closed: true }, ((options === null || options === void 0 ? void 0 : options.shapeConfig) || {})), shape.config), { shape }));
        shapesLayer.add(polygon);
        if (useEvents) {
            bindEventToPolygon(polygon, options, onClick, onShapeMouseEnter, onShapeMouseLeave);
        }
    });
};
const bindEventToPolygon = (polygon, options, onClick, onShapeMouseEnter, onShapeMouseLeave) => {
    const stage = polygon.getStage();
    const shape = polygon.getAttr('shape');
    polygon.on('mousedown', (event) => {
        var _a;
        event.cancelBubble = true;
        onClick === null || onClick === void 0 ? void 0 : onClick(shape);
        (_a = options === null || options === void 0 ? void 0 : options.onClick) === null || _a === void 0 ? void 0 : _a.call(options, polygon);
    });
    polygon.on('mouseleave', function (event) {
        var _a;
        event.cancelBubble = true;
        stage.container().style.cursor = 'inherit';
        (_a = options === null || options === void 0 ? void 0 : options.onMouseLeave) === null || _a === void 0 ? void 0 : _a.call(options, polygon);
        onShapeMouseLeave === null || onShapeMouseLeave === void 0 ? void 0 : onShapeMouseLeave(shape);
    });
    polygon.on('mouseenter', function (event) {
        var _a;
        event.cancelBubble = true;
        (_a = options === null || options === void 0 ? void 0 : options.onMouseEnter) === null || _a === void 0 ? void 0 : _a.call(options, polygon);
        stage.container().style.cursor = 'pointer';
        onShapeMouseEnter === null || onShapeMouseEnter === void 0 ? void 0 : onShapeMouseEnter(shape);
    });
};
export const scalePointToImage = (point, imageBoundingBox) => {
    const { width, height, scale } = imageBoundingBox;
    return {
        x: (point.x * width) / scale,
        y: (point.y * height) / scale,
    };
};
const mapCoordinatesToPoints = (coordinates, imageBoundingBox) => coordinates.reduce((accumulator, element) => {
    const { x, y } = scalePointToImage({ x: element[0], y: element[1] }, imageBoundingBox);
    accumulator = accumulator.concat([x, y]);
    return accumulator;
}, []);
export const getMousePosition = (stage, imageBoundingBox) => {
    if (!stage || !imageBoundingBox) {
        return;
    }
    const { x: pointerX, y: pointerY } = stage.getPointerPosition() || {
        x: 0,
        y: 0,
    };
    const oldScale = stage.scaleX();
    const stageX = stage.x();
    const stageY = stage.y();
    return {
        x: ((pointerX - stageX) * imageBoundingBox.scale) /
            (oldScale * imageBoundingBox.width),
        y: ((pointerY - stageY) * imageBoundingBox.scale) /
            (oldScale * imageBoundingBox.height),
    };
};
